export default __webpack_public_path__ + "static/media/connect_wallet_gif.d65098a5.gif";